import React, {useState, useEffect} from 'react';
import InputTel from '@homeaway/react-input-tel';

const PhoneInput = ({
    control,
    label,
    countryCodes,
    defaultCountryCode,
    error,
    errorMsg,
}) => {
    const [phoneNumber, setPhoneNumber] = useState('');
    const [phoneCode, setPhoneCode] = useState('');
    const [countryCode, setCountryCode] = useState(defaultCountryCode);
    const {setValue, register} = control;

    useEffect(() => {
        setValue('phoneNumber', phoneNumber, {shouldValidate: true});
    }, [phoneNumber, setValue]);

    useEffect(() => {
        setValue('phoneCode', phoneCode);
    }, [phoneCode, setValue]);

    const onPhoneChange = (_, phoneObject) => {
        const phoneNumberRef = control.fieldsRef.current.phoneNumber;

        if (!phoneCode) {
            // this will happen on initial render only
            setPhoneCode(phoneObject.phoneCode);
        }

        // Use initial field registration before the there's any user interaction, then add custom validation.
        // This is necessary given the phone validation result is only available during event handlers.
        //
        // So we'll have:
        //   - initial validation (required: true) before any user interaction with the field (eg. user clicks submit)
        //   - custom validation (phone is valid) as soon as the user interacts with the field (eg. user introduces a phone number)
        if (phoneNumberRef) {
            register(
                {name: 'phoneNumber'},
                {
                    required: false,
                    validate() {
                        return phoneObject.isValid;
                    },
                },
            );
        }

        if (phoneNumber !== phoneObject.raw) {
            setPhoneNumber(phoneObject.raw);
        }
    };

    const onCountryCodeChange = (_, countryObject) => {
        if (countryObject.cc !== countryCode) {
            setCountryCode(countryObject.cc);
            setPhoneCode(countryObject.phoneCode);
        }
    };

    return (
        <InputTel
            onCountryCodeChange={onCountryCodeChange}
            onPhoneChange={onPhoneChange}
            countryCode={countryCode}
            countryCodes={countryCodes}
            phoneNumber={phoneNumber}
            labels={{
                phoneNumber: label,
                countryCode: 'Country code',
            }}
            errorMsg={error ? errorMsg : ''}
        />
    );
};

export default PhoneInput;
